// @flow
import types from "./types";
import type {Action} from "../DucksUtils";

type MandatoryKeys = {||};

//TODO(Oded): create actual types
type OptionalKeys = {|
    polygons?: Array<Object>,
    polygons_list?: Array<Object>,
    merged_polygons?: Array<Object>,
    commute_polygons?: Array<Object>,
    visualServicePolygonPaths?: Array<Object>,
|}

export const ServiceConfigDefault = Object.freeze({});
export type ServiceConfig = {...MandatoryKeys, ...OptionalKeys} | OptionalKeys;

const ServiceConfigReducer = (serviceConfig: ServiceConfig = ServiceConfigDefault, action: Action): ServiceConfig => {
    const type: string = action.type;
    const payload = action.payload;
    switch (type) {
        case types.SERVICE_DATA_UPDATE:
            return {
                ...serviceConfig,
                ...payload,
            };
        case types.SERVICE_POLYGON_SET:
            return {
                ...serviceConfig,
                visualServicePolygonPaths: payload,
            };
        default:
            return serviceConfig;
    }
};

export default ServiceConfigReducer;


// WEBPACK FOOTER //
// ./src/Store/Ducks/ServiceConfig/reducers.js